import 'magnific-popup';

export default function (obj) {
    if (obj.find("a.herald-popup-img").length) {
        var popupImg = obj.find("a.herald-popup-img");
        popupImg.find('img').each(function () {
            var $that = $(this);
            if ($that.hasClass('alignright')) {
                $that.removeClass('alignright').parent().addClass('alignright');
            }
            if ($that.hasClass('alignleft')) {
                $that.removeClass('alignleft').parent().addClass('alignleft');
            }
            if ($that.hasClass('alignnone')) {
                $that.removeClass('alignnone').parent().addClass('alignnone');
            }
            if ($that.hasClass('aligncenter')) {
                $that.removeClass('aligncenter').parent().addClass('aligncenter');
            }
        });
        popupImg.magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            image: {
                titleSrc: function titleSrc(item) {
                    return item.el.closest('.wp-caption').find('figcaption').text();
                }
            }
        });
    }
}
